module.exports = __webpack_public_path__ + "img/thumb_02.9ce70f86.jpg";